<template>
  <div class="pt-4 text-center">
    <img :src="`data:image/png;base64,${qrcode}`" alt="">
  </div>
</template>

<script>
export default {
  props: ['qrcode']
}
</script>